{
  "ClientConfigurationModal_AddTitle": "Clientconfiguratie toevoegen",
  "ClientConfigurationModal_ChangeTitle": "Clientconfiguratie wijzigen",
  "ClientConfigurationModal_Footer_Actions_Submit": "Indienen",
  "ClientConfigurationModal_Footer_Actions_Cancel": "Annuleren",
  "ClientConfigurationModal_Footer_Actions_Help": "Hulp",
  "ClientConfigurationModal_Tabs_Details": "Details",
  "ClientConfigurationModal_Tabs_Scope": "Domein",
  "ClientConfigurationModal_Tabs_Policy": "Beleid",
  "ClientConfigurationModal_Tabs_Settings": "Instellingen",
  "ClientConfigurationModal_Tab_Details_Description": "Beschrijving",
  "ClientConfigurationModal_Tab_Details_Description_Required": "Beschrijving is vereist",
  "ClientConfigurationModal_Tab_Details_ID": "ID",
  "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Automatisch toegewezen]",
  "ClientConfigurationModal_Tab_Details_Override": "Overschrijf alle clientconfiguraties",
  "ClientConfigurationModal_Tab_Scope_CME": "CME",
  "ClientConfigurationModal_Tab_Scope_Telsys": "Telefonieserver",
  "ClientConfigurationModal_Tab_Scope_Telsys_Required": "Telefonieserver is vereist",
  "ClientConfigurationModal_Tab_Scope_Partition": "Partitie",
  "ClientConfigurationModal_Tab_Scope_Device": "Apparaat",
  "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Recursief filteren",
  "ClientConfigurationModal_Tab_Policy_PolicyItem": "Beleidsartikel",
  "ClientConfigurationModal_Tab_Policy_DefaultValue": "Standaardwaarde",
  "ClientConfigurationModal_Tab_Policy_ActualValue": "Werkelijke waarde",
  "ClientConfigurationModal_Policy_core": {
    "showUseConfigurationWindow": "Kern - Kan configuratievenster weergeven\/gebruiken",
    "permittedToLogin": "Kern - Toegestaan om in te loggen"
  },
  "ClientConfigurationModal_Policy_configOptions": {
    "useLocalhostAPI": "Config - gebruik Localhost API",
    "canConfigureCustomEvents": "Config - Aangepaste gebeurtenissen configureren"
  },
  "ClientConfigurationModal_Policy_menuOptions": {
    "canShowAddressBook": "Menu - Adresboek"
  },
  "ClientConfigurationModal_Policy_crm": {
    "canAddNewContacts": "Kan nieuwe contacten toevoegen aan CRM's (via wizard)"
  },
  "ClientConfigurationModal_Tab_Settings_SettingsItem": "Instellingsoptie",
  "ClientConfigurationModal_Tab_Settings_DefaultValue": "Standaardwaarde",
  "ClientConfigurationModal_Tab_Settings_ActualValue": "Werkelijke waarde",
  "ClientConfigurationModal_Settings_interface": {
    "showCallNotificationPreview": "Interface - Voorbeeld van oproepmelding weergeven",
    "showMissedCallPreview": "Interface - Voorbeeld van gemiste oproep weergeven",
    "connectedHideDelay": "Interface - Verbonden Verberg Vertraging",
    "previewWindowAlwaysOnTop": "Interface - Voorbeeldvenster altijd bovenaan",
    "showContactInEditMode": "Interface - Contact weergeven in bewerkingsmodus",
    "applicationLoadAtWindowsStartup": "Interface - Toepassingsbelasting bij het opstarten van Windows"
  },
  "ClientConfigurationModal_Settings_hotkey": {
    "makeCall": "Sneltoets - Bellen"
  },
  "ClientConfigurationModal_Settings_dialing": {
    "clipboardDialing": "Bellen - Klembordkiezen",
    "focusDialing": "Kiezen - Focuskiezen",
    "screenDialing": "Bellen - Schermkiezen"
  },
  "ClientConfigurationModal_Settings_logPage": {
    "sendAnonymouseStats": "Logpagina - Anonieme statistieken verzenden",
    "loggingLevel": "Logpagina - Logniveau"
  },
  "ClientConfigurationModal_Settings_version": {
    "checkForUpdates": "Versie - Controleer op updates en download"
  },
  "NAME": "ClientConfigurationModalLanguage",
  "ClientConfigurationModal_Error_NotFound": "Clientconfiguratie niet gevonden of bestaat niet"
}